module.exports = __webpack_public_path__ + "img/tesla-model-s.d1614a47.png";